//export const API = "http://localhost:8000/api"
export const API = "https://sridharrajaram-ecommerceserver.herokuapp.com/api"
